import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_arrow_left_line: SvgIconData = {
  viewBox: '4 4.22168 16 15.55632',
  element: (
    <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" />
  ),
};
